import React, { Component } from "react";
import { observer } from "mobx-react";
import WaveSurfer from "wavesurfer.js";

const Wave = observer(
  class Wave extends Component {
    constructor(props) {
      super(props);
      this.waveSurfer = null;
      this.state = {
        isVisible: true,
        isPlaying: false,
        duration: 0,
        currentTime: 0,
      };
    }

    componentDidMount() {
      this.fetchPeaksAndCreateWaveSurfer();
    }

    componentWillUnmount() {
      if (this.waveSurfer) {
        this.waveSurfer.destroy();
      }
    }

    fetchPeaksAndCreateWaveSurfer = async () => {
      try {
        const response = await fetch(this.props.peaksUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const peaks = await response.json();
        const numericPeaks = peaks.map(parseFloat);
        if (this.validatePeaks(numericPeaks)) {
          this.createWaveSurfer(numericPeaks);
        } else {
          throw new Error("Invalid peaks format");
        }
      } catch (error) {
        console.error("Error fetching peaks:", error);
        this.createWaveSurfer();
      }
    };

    validatePeaks = (peaks) => {
      return (
        Array.isArray(peaks) &&
        peaks.every((value) => typeof value === "number")
      );
    };

    createWaveSurfer = (peaks) => {
      const container = document.getElementById(`waveform-${this.props.id}`);
      if (!container) {
        console.error("Waveform container not found");
        return;
      }

      this.waveSurfer = WaveSurfer.create({
        container: container,
        waveColor: "gray",
        progressColor: "black",
        height: 23,
        barGap: 1,
        barHeight: 1,
        barWidth: 2,
      });

      if (peaks) {
        this.waveSurfer.load(this.props.audioUrl, peaks);
      } else {
        this.waveSurfer.load(this.props.audioUrl);
      }

      this.waveSurfer.on("ready", () => {
        this.setState({ duration: this.waveSurfer.getDuration() });
      });
      this.waveSurfer.on("audioprocess", () => {
        this.setState({ currentTime: this.waveSurfer.getCurrentTime() });
      });
      this.waveSurfer.on("error", (error) => {
        console.error("Error loading audio:", error);
      });
      this.waveSurfer.on("finish", () => {
        this.setState({ isPlaying: false });
      });
    };

    formatTime = (time) => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    togglePlay = () => {
      const { isPlaying } = this.state;
      if (isPlaying) {
        this.waveSurfer.pause();
      } else {
        this.waveSurfer.play();
      }
      this.setState({ isPlaying: !isPlaying });
    };

    render() {
      const { duration } = this.state;
      const { clickable = true } = this.props;
      return (
        <div className="flex flex-1 flex-row gap-x-5 justify-center items-center">
          <div
            id={`waveform-${this.props.id}`}
            className={`w-[300px] ${
              this.props.width && `w-[${this.props.width}px]`
            } ${!clickable && "select-none pointer-events-none"}`}
            onClick={this.togglePlay}
          ></div>
          <div className="font-medium text-xs text-[#130D0D] select-none">
            {this.formatTime(duration)}
          </div>
        </div>
      );
    }
  }
);

export default Wave;
